module.exports = __webpack_public_path__ + "static/bride-window-681c5572534b4cad613ca0837d7da09b.jpg";